module.exports = __webpack_public_path__ + "img/p32-desc.73522c39.png";